import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { TechnologicalTransferCard } from './components/Card/TechnologicalTransferCard';
import { getTechnologicalTransferPagedOptions } from './model/TechnologicalTransferQuery';

export function TechnologicalTransferBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });
  const { data } = useSuspenseQuery(
    getTechnologicalTransferPagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink to="search-claimable" />}
      title={t('technologicalTransfers.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('technologicalTransfers.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('technologicalTransfers.sortedByCreatedAt')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={technologicalTransfer => (
        <TechnologicalTransferCard
          key={technologicalTransfer.id}
          technologicalTransfer={technologicalTransfer}
          to={`${technologicalTransfer.id}`}
        />
      )}
    />
  );
}
